export default __webpack_public_path__ + "static/media/gallery_04.92e3a75c.jpg";